import makeStyles from "@mui/styles/makeStyles";

export const useStyles = makeStyles((theme) => ({
  addSection: {
    backgroundColor: theme.palette.grey[50],
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(3),
    border: `1px solid ${theme.palette.grey[200]}`,
  },
  attributeRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: theme.spacing(1.5, 2),
    border: `1px solid ${theme.palette.grey[200]}`,
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.palette.common.white,
    transition: "border-color 0.15s ease",
    "&:hover": {
      borderColor: theme.palette.grey[400],
    },
  },
  attributeRowLeft: {
    display: "flex",
    alignItems: "center",
    flex: 1,
    minWidth: 0,
  },
  attributeRowMid: {
    flex: 1,
    minWidth: 0,
    padding: theme.spacing(0, 2),
  },
  defaultValuePill: {
    display: "inline-flex",
    alignItems: "center",
    padding: theme.spacing(0.25, 1.5),
    borderRadius: 9999,
    backgroundColor: theme.palette.grey[100],
    border: `1px solid ${theme.palette.grey[200]}`,
    maxWidth: "100%",
    overflow: "hidden",
  },
  sectionHeader: {
    display: "flex",
    alignItems: "center",
    marginBottom: theme.spacing(2),
  },
  emptyState: {
    textAlign: "center",
    padding: theme.spacing(5, 3),
    border: `1px dashed ${theme.palette.grey[300]}`,
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.palette.grey[50],
  },
  deleteBtn: {
    opacity: 0.5,
    transition: "opacity 0.15s ease",
    "&:hover": {
      opacity: 1,
    },
  },
}));
